import CloseIcon from '@material-ui/icons/Close';
import Div100vh from 'react-div-100vh';
import { MapInteractionCSS } from 'react-map-interaction';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../redux/store';
import { useEffect } from 'react';
import { TRACK_EVENT, trackEvent } from '../../utils/analytics';
import { setTrackingData } from '../../redux/analytic/analytic.slice';
import { PrivateImage } from 'features/authorize/private_img';
import Drawer from '@material-ui/core/Drawer';
function ZoomImage({ img, setShowImage, isPrivateImage = false }) {
    const { trackingData } = useSelector((state: RootState) => state.analytic);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (trackingData) {
            trackEvent(TRACK_EVENT.ENLARGE_PRODUCT_IMAGE_OPEN, trackingData);
        }
    }, [trackingData]);

    const handleClose = () => {
        trackEvent(TRACK_EVENT.ENLARGE_PRODUCT_IMAGE_CLOSE, trackingData ?? {});
        dispatch(setTrackingData(null));
        setShowImage(false);
    };

    return (
        <Drawer
            open={Boolean(img)}
            onClose={handleClose}
            anchor={'bottom'}
            PaperProps={{
                style: {
                    margin: 0,
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    right: 0,
                    top: 0,
                    bottom: 0,
                    zIndex: 1999,
                    overflow: 'hidden',
                    width: '100%',
                    background: 'white',
                },
            }}
        >
            <div
                style={{
                    position: 'relative',
                    height: '100%',
                    width: '100%',
                }}
            >
                <CloseIcon
                    style={{
                        color: `black`,
                        position: 'absolute',
                        width: 20,
                        right: 28,
                        top: 17,
                        zIndex: 2001,
                    }}
                    onClick={handleClose}
                />
                {/* {!isDisplay &&
                    <Div100vh style={{
                        margin: 0,
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        zIndex: 2000,
                        overflow: 'hidden',
                        width: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <div style={{ width: 'auto', textAlign: 'center' }} onClick={() => setIsDisplay(true)}>
                            <HandZoomImg />
                            <TitlePage>Zoom</TitlePage>
                            <TextNormal style={{ fontSize: 16 }}>With your fingers</TextNormal>
                        </div>
                    </Div100vh>
                } */}
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <MapInteractionCSS>
                        <Div100vh
                            style={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {isPrivateImage ? (
                                <PrivateImage
                                    url={img}
                                    style={{
                                        width: '100vw',
                                        height: '100%',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundSize: 'contain',
                                    }}
                                />
                            ) : (
                                <img
                                    src={img}
                                    alt="item"
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        objectFit: 'cover',
                                    }}
                                />
                            )}
                        </Div100vh>
                    </MapInteractionCSS>
                </div>
            </div>
        </Drawer>
    );
}

export default ZoomImage;
